import React from 'react';
import styled from 'styled-components';

import Icon from '@components/dataDisplay/Icons/Icon';

const SwapIconWrap = styled.div`
  position: absolute;
  top: 50%;
  transform: translateX(0) translateY(-50%);
  left: 2px;
  padding: 8px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  z-index: 1;

  &:hover {
    cursor: grab;
  }
`;

type Props = {
  listeners?: any;
  attributes?: any;
  style?: React.CSSProperties;
};

function SwapIconSec({ style, ...props }: Props) {
  return (
    <SwapIconWrap style={style} {...props} className="swapIcon">
      <Icon name="Swap14" color="var(--subTextColor)" />
    </SwapIconWrap>
  );
}

export default SwapIconSec;
